"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../");

var _sharedInputStyles = require("./sharedInputStyles");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["disabled", "name", "type", "value", "placeholder", "onChange", "onFocus", "onBlur", "isError", "isMandatory", "isReadOnly", "prefix", "hasFullBorder", "fontStyle", "flex"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  flex: ", ";\n"])), _sharedInputStyles.wrapperStyles, function (p) {
  return p.flex;
});

var StyledPrefix = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-style: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", ";\n"])), function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.inputFontStyle;
}, function (p) {
  return p.theme.inputFontSize;
}, function (p) {
  return p.theme.inputFontFamily;
}, function (p) {
  return p.theme.inputFontWeight;
}, function (p) {
  return p.isMandatory ? "margin-left: 0.25rem;" : p.theme.inputBorderStyle === "full" ? "margin-left: 1rem;" : null;
});

var StyledReadOnly = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), _sharedInputStyles.inputStyles);

var StyledInput = _styledComponents.default.input(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), _sharedInputStyles.inputStyles, function (p) {
  return p.theme.colorLabel;
});

var StyledMandatory = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n"])), _sharedInputStyles.mandatoryStyles);

var StyledLocked = (0, _styledComponents.default)(_.MatIcon)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 1rem;\n  transform: translateY(-50%);\n  font-size: 1rem;\n  color: ", ";\n  border-radius: 50%;\n  pointer-events: none;\n"])), function (p) {
  return p.theme.colorText;
});

var FormTextbox = function FormTextbox(_ref) {
  var disabled = _ref.disabled,
      name = _ref.name,
      type = _ref.type,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      isError = _ref.isError,
      isMandatory = _ref.isMandatory,
      isReadOnly = _ref.isReadOnly,
      prefix = _ref.prefix,
      hasFullBorder = _ref.hasFullBorder,
      fontStyle = _ref.fontStyle,
      flex = _ref.flex,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setFocused = _useState2[1];

  var handleFocused = function handleFocused(e) {
    setFocused(true);
    onFocus(e);
  };

  var handleBlurred = function handleBlurred(e) {
    setFocused(false);
    onBlur(e);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    flex: flex,
    isFocused: isFocused,
    isError: isError,
    hasFullBorder: hasFullBorder,
    children: [disabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLocked, {
      children: "lock"
    }), isMandatory && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMandatory, {
      children: "*"
    }), prefix && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPrefix, {
      isMandatory: isMandatory,
      children: prefix
    }), isReadOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledReadOnly, {
      children: value
    }), !isReadOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledInput, _objectSpread({
      disabled: disabled,
      value: value,
      name: name,
      onChange: onChange,
      onFocus: handleFocused,
      onBlur: handleBlurred,
      type: type,
      placeholder: placeholder,
      hasFullBorder: hasFullBorder,
      hasPrefix: prefix,
      isMandatory: isMandatory
    }, rest))]
  });
};

FormTextbox.defaultProps = {
  type: "text",
  onBlur: function onBlur() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  }
};
FormTextbox.propTypes = {
  disabled: _propTypes.default.bool,
  value: _propTypes.default.string,
  type: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onfocus: _propTypes.default.func,
  placeholder: _propTypes.default.string
};
var _default = FormTextbox;
exports.default = _default;